import { render, staticRenderFns } from "./consent-disclaimer.vue?vue&type=template&id=1735162a&scoped=true&"
import script from "./consent-disclaimer.vue?vue&type=script&lang=js&"
export * from "./consent-disclaimer.vue?vue&type=script&lang=js&"
import style0 from "./consent-disclaimer.vue?vue&type=style&index=0&id=1735162a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1735162a",
  null
  
)

component.options.__file = "consent-disclaimer.vue"
export default component.exports